import { ProfileContext } from "../context/ProfileContext";
import { useContext } from "react";

export const useProfile = () => {
    const context = useContext(ProfileContext)

    if (context === undefined) {
        console.log("useProfile must be used within a ProfileProvider")
        throw new Error("useProfile must be used within a ProfileProvider");
    }

    return context;
}   